<template>
  <div>
    <div class="list-analytics analysis-chart" v-show="mainChartVisible">
      <div class="t-chart c-pointer">
        <div class="title corner" @click="onClickAddButton">
            온도11
            <div :class="addButtonIconName"></div>
        </div>
        <w-plot-line-chart ref="ftemp11Chart" :active="active" :visible="mainChartVisible" :rscInfoList="mainRscInfoList" @clickChart="onClickChart"/>
      </div>
    </div>

    <div v-show="subChartVisible" class="sub-chart-wrapper">
      <div class="list-analytics analysis-chart">
        <div class="t-chart">
          <div class="title">온도12</div>
          <w-plot-line-chart ref="ftemp12Chart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['TEMPERATURE12']" @clickChart="onClickChart"/>
        </div>
      </div>
      <div class="list-analytics analysis-chart">
        <div class="t-chart">
          <div class="title">온도13</div>
          <w-plot-line-chart ref="ftemp13Chart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['TEMPERATURE13']" @clickChart="onClickChart"/>
        </div>
      </div>
      <div class="list-analytics analysis-chart">
        <div class="t-chart">
          <div class="title">온도14</div>
          <w-plot-line-chart ref="ftemp14Chart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['TEMPERATURE14']" @clickChart="onClickChart"/>
        </div>
      </div>
      <div class="list-analytics analysis-chart">
        <div class="t-chart">
          <div class="title">온도15</div>
          <w-plot-line-chart ref="ftemp15Chart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['TEMPERATURE15']" @clickChart="onClickChart"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { performanceChart } from '@/mixins/performance/charts';
import WPlotLineChart from '@/views/performance/node/analysis/components/PlotLineChart';

export default {
  name: 'WFtemp11AnalysisChart',
  components: { WPlotLineChart },
  mixins: [performanceChart],
  props: {
    chartVisible: Boolean,
  },
  data() {
    return {
      mainRscInfoList: [{ rsctypeId: 'FTEMP', rscId: 'TEMPERATURE11', rscKey: '_' }],
      subRscInfo: {
        TEMPERATURE12: [{ rsctypeId: 'FTEMP', rscId: 'TEMPERATURE12', rscKey: '_' }],
        TEMPERATURE13: [{ rsctypeId: 'FTEMP', rscId: 'TEMPERATURE13', rscKey: '_' }],
        TEMPERATURE14: [{ rsctypeId: 'FTEMP', rscId: 'TEMPERATURE14', rscKey: '_' }],
        TEMPERATURE15: [{ rsctypeId: 'FTEMP', rscId: 'TEMPERATURE15', rscKey: '_' }],
      },
      subChartVisible: false,
      addButtonIconName: 'triangle add',
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/sensor/components/chart/Ftemp11AnalysisChart.vue